import { forwardRef } from 'react'

import { SelectSize, SelectTriggerProps } from '../Select.types'
import { SelectComponentsContent } from '../SelectComponentsContent/SelectComponentsContent'
import { SelectTriggerBasic } from './SelectTriggerBasic'

export const SelectTrigger = forwardRef<HTMLButtonElement, SelectTriggerProps>(
  (
    {
      selectedItem,
      placeholder,
      placeholderIcon,
      size = SelectSize.Medium,
      selectStyle,
      ...rest
    },
    ref
  ) => {
    return (
      <SelectTriggerBasic {...rest} size={size} ref={ref}>
        <SelectComponentsContent
          image={selectedItem?.image}
          label={selectedItem?.label || placeholder || ''}
          subLabel1={selectedItem?.subLabel1}
          subLabel2={selectedItem?.subLabel2}
          icon={selectedItem?.icon || placeholderIcon}
          avatar={selectedItem?.avatar}
          size={size}
          selectStyle={selectStyle}
          hasValue={Boolean(selectedItem?.label)}
        />
      </SelectTriggerBasic>
    )
  }
)
